import { breakpoint } from 'utils/consts/breakpoints'
import styled from 'styled-components'

export const Title = styled.div<{ hasError?: boolean }>`
  font: var(--typography-14-16-semibold);
  color: ${props => (props.hasError ? '#D00A00' : 'var(--color-sw-60)')};
  display: flex;
  margin-bottom: 4px;
  gap: 4px;
`

export const Input = styled.input`
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
  pointer-events: ${props => (props.readOnly ? 'none' : '')};
`

export const EmptyIcon = styled.svg<{ readOnly?: boolean }>`
  circle {
    fill: ${props => (props.readOnly ? '#E7E7EA' : 'var(--color-brand-red)')};
  }

  path {
    fill: ${props => (props.readOnly ? '#D0D0D6' : 'white')};
  }
`

export const Wrapper = styled.div`
  @media screen and ${breakpoint.s} {
    aspect-ratio: 1 / 1;
  }
`

export const DragZoneWrapper = styled.div<{
  readOnly?: boolean
  empty?: boolean
  dragging?: boolean
  hasError?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => (props.readOnly ? 'auto' : 'pointer')};
  border: ${props => {
    const style = props.empty ? 'dashed' : 'solid'
    let color
    if (props.empty && props.readOnly) return 'none'
    if (props.dragging) color = '#3b42a5'
    else if (props.hasError) color = '#D00A00'
    else if (props.empty) color = 'var(--color-sw-20)'
    else color = '#e7e7ea'

    return `${style} 1px ${color}`
  }};
  width: 170px;
  height: 170px;

  @media screen and ${breakpoint.s} {
    width: 100%;
    height: 100%;
  }

  background: ${props =>
    props.dragging ? 'rgba(59, 66, 165, .1)' : '#ffffff'};
  border-radius: 8px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
`

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--color-brand-red);
`
export const EmptyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const EmptyText = styled.div`
  color: var(--color-sw-60);
  font: var(--typography-12-16-regular);
  margin-top: 8px;
  margin-bottom: -24px;
`
